// extracted by mini-css-extract-plugin
export default {"wrapper":"DDTAnother_wrapper__0Y7Ri","title":"DDTAnother_title__Rqs+R","container":"DDTAnother_container__+gkb8"};